import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TaskGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    authService.loadPermissions();
  }

  canActivate(
    activatedRouteSnapshot: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const tasksOwned = this.authService.permissions;

    const tasksRequired = activatedRouteSnapshot.data['task'];

    if (tasksOwned[tasksRequired]) {
      return true;
    } else {
      this.router.navigate(['layout/dashboard'], {relativeTo: this.route});
      return false;
    }
  }
}
